import { defaultConfigState } from './constants';

/**
 * @param {*} data
 * @returns {defaultConfigState}
 */
export function parseConfigToConfigState(data) {
  if (!data) return defaultConfigState;
  const { TipoEntregaCheck } = data;

  return {
    existe: true,
    idConfig: data.Id,
    tiposEntrega: String(data.TiposEntrega || 3),
    cobrarMaior: data.CobrarValorMaior,
    freteGratis: data.FreteGratis,
    bloquearObs: data.BloquearObservacao,
    mensagemObs: data.MensagemObservacao,
    mensagem: data.Mensagem,
    vendaLojaFechada: data.VendaLojaFechada,
    mensagemVendaLojaFechada: data.MensagemVendaLojaFechada,
    faceBookPixel: data.FaceBookPixel,
    googleTagManager: data.GoogleTagManager || '',
    mostrarCategoriasInicio: +data.MostrarCategoriasInicio,
    mostrarPromocoesInicio: +data.MostrarPromocoesInicio,
    vendaSemAutenticacao: data.VendaSemAutenticacao,
    vendaBloqueadaCartaoLivre: data.VendaBloqueadaCartaoLivre,
    localEntrega: data.LocalEntrega,
    retirarTotalizador: !!+data.RetirarTotalizador,
    exibirBairrosDisponiveis: !!+data.ExibirBairrosDisponiveis,
    limiteMinimoCompra: data.LimiteMinimoCompra ? data.LimiteMinimoCompra : 0,
    logoMarca: data.Logomarca,
    logoFundo: data.Background,
    tema: data.Tema,
    latitude: data.Latitude,
    longitude: data.Longitude,
    fusoHorario: data.FusoHorario,
    ordenacaoProdutoValor: data.OrdenacaoProdutoValor ?? 0,
    diasAgendamento: data.DiasAgendamento
      ? JSON.parse(data.DiasAgendamento)
      : null,
    mostrarEndereco: data.MostrarEndereco,
    backgroundImage: data.UseHomeBackground,
    appThemeType: data.TipoTema || 'light',
    showCoupon: data.MostrarCupom ?? 1,
    minTimePickUp: data.MinTimePickUp,
    maxTimePickUp: data.MaxTimePickUp,
    minTimeDelivery: data.MinTimeDelivery,
    maxTimeDelivery: data.MaxTimeDelivery,
    tipoEntregaCheck:
      typeof TipoEntregaCheck === 'string' ? TipoEntregaCheck.split(';') : [],
    canSignUp: data.CanSignUp,
    orderNeighborhood: data.OrderNeighborhood,
    crossSelling: data.CrossSelling,
    enablePaymentAsaas: data.EnableAsaasPayment,
    asaasExpirationTimePix: data.AsaasExpirationTimePix,
    sellOnlyWithLogin: data.SellOnlyWithLogin,
    layout: data.Layout,
    requiredProofOfPayment: data.RequiredProofOfPayment,
    disableOrdersActions: data.DisableOrdersActions,
    hideAppPrice: data.HideAppPrice,
    notificationPushSong: data.NotificationPushSong || 1,
    enableMostOrdered: data.EnableMostOrdered || 0,
    cardapioVisualizacao: data.CardapioVisualizacao || 0,
    verChamaGarcom: data.VerChamaGarcom || 0,
    endSessionAfterOrder: data.EndSessionAfterOrder || false,
    enableRequestBill: data.EnableRequestBill || false,
    selectPizzaSizeFirst: data.SelectPizzaSizeFirst || false,
    enableRepeatOrder: data.EnableRepeatOrder || false,
    identificationCustomer: data.IdentificationCustomer || false,
    enableProductSuggestions: data.EnableProductSuggestions ?? true,
    requirePizzaBorder: data.RequirePizzaBorder || false,
    seeCompleteProductComposition: data.SeeCompleteProductComposition ?? true,
    disableOrdersTotal: data.DisableOrdersTotal || false,
  };
}

/**
 * @param {defaultConfigState} configState
 */
export function parseConfigStateToConfig(configState) {
  return {
    TiposEntrega: configState.tiposEntrega,
    CobrarValorMaior: configState.cobrarMaior,
    FreteGratis: configState.freteGratis,
    BloquearObservacao: configState.bloquearObs,
    MensagemObservacao: configState.mensagemObs,
    VendaLojaFechada: configState.vendaLojaFechada,
    MensagemVendaLojaFechada: configState.mensagemVendaLojaFechada,
    Tema: configState.tema,
    Mensagem: configState.mensagem,
    Latitude: configState.latitude,
    Longitude: configState.longitude,
    FusoHorario: configState.fusoHorario,
    LimiteMinimoCompra: configState.limiteMinimoCompra,
    OrdenacaoProdutoValor: configState.ordenacaoProdutoValor,
    VendaSemAutenticacao: configState.vendaSemAutenticacao,
    VendaBloqueadaCartaoLivre: configState.vendaBloqueadaCartaoLivre,
    LocalEntrega: configState.localEntrega,
    RetirarTotalizador: Number(configState.retirarTotalizador),
    ExibirBairrosDisponiveis: Number(configState.exibirBairrosDisponiveis),
    MostrarCategoriasInicio: configState.mostrarCategoriasInicio,
    MostrarEndereco: configState.mostrarEndereco,
    UseHomeBackground: configState.backgroundImage,
    TipoTema: configState.appThemeType,
    FaceBookPixel: configState.faceBookPixel,
    GoogleTagManager:
      (configState.googleTagManager || '').trim().toUpperCase() || null,
    MostrarPromocoesInicio: configState.mostrarPromocoesInicio,
    MostrarCupom: configState.showCoupon,
    MinTimePickUp: configState.minTimePickUp,
    MaxTimePickUp: configState.maxTimePickUp,
    MinTimeDelivery: configState.minTimeDelivery,
    MaxTimeDelivery: configState.maxTimeDelivery,
    TipoEntregaCheck:
      configState.tipoEntregaCheck.length > 0
        ? configState.tipoEntregaCheck.join(';')
        : null,
    CanSignUp: configState.canSignUp,
    OrderNeighborhood: configState.orderNeighborhood,
    CrossSelling: configState.crossSelling,
    EnableAsaasPayment: configState.enablePaymentAsaas,
    AsaasExpirationTimePix: configState.asaasExpirationTimePix,
    SellOnlyWithLogin: configState.sellOnlyWithLogin,
    Layout: configState.layout,
    RequiredProofOfPayment: configState.requiredProofOfPayment,
    DisableOrdersActions: configState.disableOrdersActions,
    HideAppPrice: configState.hideAppPrice,
    NotificationPushSong: configState.notificationPushSong,
    EnableMostOrdered: configState.enableMostOrdered,
    CardapioVisualizacao: configState.cardapioVisualizacao,
    VerChamaGarcom: configState.verChamaGarcom,
    EndSessionAfterOrder: configState.endSessionAfterOrder,
    EnableRequestBill: configState.enableRequestBill,
    SelectPizzaSizeFirst: configState.selectPizzaSizeFirst,
    EnableRepeatOrder: configState.enableRepeatOrder,
    IdentificationCustomer: configState.identificationCustomer,
    EnableProductSuggestions: configState.enableProductSuggestions,
    RequirePizzaBorder: configState.requirePizzaBorder,
    SeeCompleteProductComposition: configState.seeCompleteProductComposition,
    DisableOrdersTotal: configState.disableOrdersTotal,
  };
}
